var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "over-auto": _vm.showWay === "table" } },
    [
      !_vm.hideViewWayTabs
        ? _c(
            "yxt-radio-group",
            {
              staticClass: "gwnl-web-radio-group2",
              on: { change: _vm.changed },
              model: {
                value: _vm.showWay,
                callback: function ($$v) {
                  _vm.showWay = $$v
                },
                expression: "showWay",
              },
            },
            [
              _c("yxt-radio-button", { attrs: { label: "radar" } }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("pc_gwnl_web_radar")) + "\n    "
                ),
              ]),
              _c("yxt-radio-button", { attrs: { label: "table" } }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("pc_gwnl_web_table")) + "\n    "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.scene === 2 && !_vm.hideViewWayTabs
        ? _c(
            "yxtf-tooltip",
            {
              attrs: {
                content: _vm.$t(
                  "pc_gwnl_web_training_tip" /**多次测评进行比较，得分将统一转化为10分制 */
                ),
                placement: "top",
              },
            },
            [
              _c("yxtf-svg", {
                staticClass: "color-gray-6 hover-primary-6 ml6",
                staticStyle: { position: "absolute", top: "6px" },
                attrs: {
                  "remote-url":
                    _vm.gwnlMediaDomain + "media/images/pc_svg/common",
                  width: "20px",
                  height: "20px",
                  "icon-class": "tooltip",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt32" },
        [
          _vm.showWay === "radar"
            ? _c("skills-radar", {
                attrs: {
                  "close-animate": _vm.closeAnimate,
                  fields: _vm.fields,
                  hideSkillLevelBeforeEval: _vm.hideSkillLevelBeforeEval,
                  skillWithLevel: _vm.skillWithLevel,
                  skillsList: _vm.detail.jqSkillClassifications || [],
                },
              })
            : _vm._e(),
          _vm.showWay === "table"
            ? _c("skills-table", {
                attrs: {
                  fields: _vm.fields,
                  skillWithLevel: _vm.skillWithLevel,
                  skillsList: _vm.detail.jqSkillClassifications || [],
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }